import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NotificationCenterComponent } from '@fantaz/shared/notification-center';
import { SharedUiColorSchemeSwitcherModule } from '@fantaz/shared/ui/color-scheme-switcher';
import { CurrencyModule, CurrencyPipe } from '@fantaz/shared/ui/currency';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { NavbarUserComponent } from './navbar-user.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    CurrencyModule,
    CurrencyPipe,
    SharedUiColorSchemeSwitcherModule,
    NotificationCenterComponent,
  ],
  declarations: [NavbarUserComponent],
  bootstrap: [NavbarUserComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [NavbarUserComponent],
  providers: [CurrencyPipe],
})
export class NavbarUserModule {}
